import styled from 'styled-components';

export const Note = styled.div`
  background-color: lightgray;
`;
